import { Container, Typography, Box, Button } from '@mui/material';
import logoCabanaWhite from '../../images/logonextcabana-white.svg';
import AppTheme from '../../../frontend/shared-theme/AppTheme';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { auth } from '../../../contexts/authentication';
import { applyActionCode } from 'firebase/auth';

function VerifyEmailContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [verificationError, setVerificationError] = useState<string | null>(null);
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    async function verifyEmail() {
      try {
        const params = new URLSearchParams(location.search);
        const actionCode = params.get('oobCode');

        if (!actionCode) {
          setVerificationError('Código de verificação não encontrado.');
          setIsVerifying(false);
          return;
        }

        await applyActionCode(auth, actionCode);
        setIsVerifying(false);
      } catch (error: any) {
        console.error('Erro ao verificar email:', error);
        setVerificationError(error.message);
        setIsVerifying(false);
      }
    }

    verifyEmail();
  }, [location]);

  if (isVerifying) {
    return (
      <Container component="main" sx={{ maxWidth: 'xs', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
          <img
            src={logoCabanaWhite}
            alt="logo-cabanalink"
            style={{ width: '300px', height: 'auto' }}
          />
        </div>
        <Box sx={{ mt: 8 }}>
          <Typography>Verificando seu email...</Typography>
        </Box>
      </Container>
    );
  }

  if (verificationError) {
    return (
      <Container component="main" sx={{ maxWidth: 'xs', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
          <img
            src={logoCabanaWhite}
            alt="logo-cabanalink"
            style={{ width: '300px', height: 'auto' }}
          />
        </div>
        <Box sx={{ mt: 8 }}>
          <Typography color="error">
            Erro ao verificar email: {verificationError}
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 3 }}
            onClick={() => navigate('/signin')}
          >
            Voltar para login
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container component="main" sx={{ maxWidth: 'xs', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
        <img
          src={logoCabanaWhite}
          alt="logo-cabanalink"
          style={{ width: '300px', height: 'auto' }}
        />
      </div>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <Typography component="h1" variant="h4" textAlign='center'>
          Parabéns!
        </Typography>
        <Typography textAlign='center'>
          Seu e-mail agora está verificado.
        </Typography>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, maxWidth: '200px' }}
          onClick={() => navigate('/dashboard')}
        >
          Começar agora
        </Button>
      </Box>
    </Container>
  );
}

export default function VerifyEmail(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <VerifyEmailContent />
    </AppTheme>
  )
}